import React from 'react';

const NewIcon: React.FC = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 320 320" style={{ marginLeft: '5px' }}>
      <text x="80" y="160" fontSize="80" fill="#6930CA">
        NEW
        <animate
          attributeName="fill"
          values="#6930CA; #FFFFFF; #6930CA"
          dur="0.8s"
          repeatCount="indefinite"
        />
      </text>
    </svg>
  );
};

export default NewIcon;